import { call, put } from "redux-saga/effects";
import {
  AdminDashboardStatsResponse,
  AdminWalletResponse,
} from "reduxStore/dataTypes";
import { fetchAdminDashboard, fetchAdminWallet } from "services/apiService";
import {
  adminDashboardStatsFailure,
  adminDashboardStatsRequest,
  adminDashboardStatsSuccess,
} from "../reducers/adminDashboardStatsReducer";

function* adminDashboardSaga(): Generator<
  any,
  void,
  AdminDashboardStatsResponse | any
> {
  try {
    yield put(adminDashboardStatsRequest());
    const response = yield call(fetchAdminDashboard);
    yield put(adminDashboardStatsSuccess(response.data));
  } catch (error: any) {
    if (error && error.response) {
      yield put(adminDashboardStatsFailure(error.response));
    } else {
      yield put(adminDashboardStatsFailure(error.message));
    }
  }
}

export default adminDashboardSaga;
